module.exports = __webpack_public_path__ + "static/media/39.5a696c95.png";